import React from 'react';

import styled from 'styled-components';

import CareTypeFilter from 'common/Filters/CareTypeFilter';
import CompetitorsFilter from 'common/Filters/CompetitorsFilter';
import ContractTypeFilter from 'common/Filters/ContractTypeFilter';
import ReviewSourceFilter from 'common/Filters/ReviewSourceFilter';
import RoomTypeFilter from 'common/Filters/RoomTypeFilter';
import { hasAnyCCRCCompetitor, isCommunityCCRC } from 'components/Community/utils';
import { canViewPricingData } from 'helpers/permissions';
import { useAppSelector } from 'store/hook';

import CompareCommunitiesFilter from './CompareCommunitiesFilter/CompareCommunitiesFilter';
import CustomCommunityContractTypeFilter from './CustomCommunityContractTypeFilter';
import DataQuarterFilter from './DataQuarterFilter/DataQuarterFilter';
import HeaderViewFiltersCareLevel from './HeaderViewFiltersCareLevel';
import HeaderViewFiltersCompare from './HeaderViewFiltersCompare';
import HeaderViewFiltersReviewCategory from './HeaderViewFiltersReviewCategory';
import HeaderViewFiltersSwotCategory from './HeaderViewFiltersSwotCategory';
import { useCommunityViewContext } from '../CommunityViewContext';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: start;
  gap: 5px;
`;

const HeaderViewFiltersMenu = () => {
  const { view, competitorId, competitors, viewFilters, community, isViewSalesBattlecard } = useCommunityViewContext();
  const currentUser = useAppSelector((state) => state.auth.currentUser);
  const showPricingData = canViewPricingData(currentUser);

  const competitorsFilterOptions = competitors?.map((item) => ({
    label: item.comunity_name,
    value: item.id,
    color: item.color,
  }));

  const showGlobalFilters = view?.default || isViewSalesBattlecard;
  const limitOverviewFilters = !showPricingData && !isViewSalesBattlecard;

  return (
    <Container>
      {!isViewSalesBattlecard && <DataQuarterFilter />}
      {competitorId ? (
        <HeaderViewFiltersCompare />
      ) : (
        <>
          <CompareCommunitiesFilter />
          {!isViewSalesBattlecard && (
            <CompetitorsFilter competitors={viewFilters?.competitors || []} options={competitorsFilterOptions} />
          )}
        </>
      )}
      {showGlobalFilters && !limitOverviewFilters && (
        <>
          <CareTypeFilter careTypes={viewFilters?.careTypes} />
          {!isViewSalesBattlecard && isCommunityCCRC(community?.rental_types) && <ContractTypeFilter />}
          <RoomTypeFilter roomTypes={viewFilters?.roomTypes} />
          <HeaderViewFiltersCareLevel />
          <ReviewSourceFilter reviewSources={viewFilters?.reviewSources} />
          <HeaderViewFiltersReviewCategory />
          {!isViewSalesBattlecard && <HeaderViewFiltersSwotCategory />}
        </>
      )}
      {!limitOverviewFilters &&
        !isViewSalesBattlecard &&
        !isCommunityCCRC(community?.rental_types) &&
        hasAnyCCRCCompetitor(competitors ?? []) && <CustomCommunityContractTypeFilter />}
    </Container>
  );
};

export default HeaderViewFiltersMenu;
